export default __webpack_public_path__ + "static/media/crosshairs.1076bdfb.svg";